import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { element } from 'protractor';
import { Observable } from 'rxjs';
import { BreakdownCategory, BreakdownCode, CodePanne } from 'src/app/model/breakdowns/breakdown';
import { Action, TypeAppel } from 'src/app/model/gestion/gestion';
import { DialogConfirmServiceService } from 'src/app/services/dialog-confirm-service.service';
import { BreakdownsService } from 'src/app/services/http/breakdowns/breakdowns.service';
import { GestionActionsSavService } from 'src/app/services/http/gestion/gestion-actions-sav.service';
import { GestionTypesAppelsService } from 'src/app/services/http/gestion/gestion-types-appels.service';
import { DialogOverViewComponent } from '../dialog-over-view/dialog-over-view.component';
import { EditGestionComponent } from './edit-gestion/edit-gestion/edit-gestion.component';

@Component({
  selector: 'app-gestion',
  templateUrl: './gestion.component.html',
  styleUrls: ['./gestion.component.scss']
})
export class GestionComponent implements OnInit {

  get displayedColumnCat(): string[] {
    const result: string[] = ['nom', 'code', 'edit', 'delete'];
    return result;
  }

  get displayedColumnCode(): string[] {
    const result: string[] = ['code', 'nom', 'edit', 'delete'];
    return result;
  }

  /**
   * category Breakdown form
   */
  pannesCategoriesForm!: FormGroup;

  /**
     * code Breakdown form
    */
  codesPannesForm!: FormGroup;

  /* List of all breakdowns categories */
  categoryBreakdownList!: BreakdownCategory[];

  /* one breakdown category */
  category: BreakdownCategory = {
    cat_nom: "",
    cat_code: ""
  };

  /* List of all breakdowns categories */
  codesBreakdownList!: BreakdownCode[];

  /* List of all codes_pannes data */
  codesPannesList !: CodePanne[];

  /* Display category list */
  displayCategoryList: boolean = false;

  /* Display category list */
  displayCodesList: boolean = false;

  /* Message by default on display category list button  */
  catMessage: string = "Afficher la liste";

  /* Message by default on display code list button  */
  codeMessage: string = "Afficher la liste";

  /* Array that contains all the breakdowns categories and their associated id */
  tCategories: Array<any> = [];

  /* Knowing if we add or delete */
  isAddMode: boolean = true;

  /* All messages  */
  messageDialog: string = '';
  newCategoryAddedMsg: string = "Catégorie de panne ajoutée";
  newCodePanneAddedMsg: string = "Code panne ajouté";
  itemDeletedSuccessMsg: string = "Élément supprimé";
  itemDeletedFailureMsg: string = "Suppression impossible : veuillez d'abord supprimer tous les codes pannes associés à cette catégorie ";

  newCategoryBreakdown: BreakdownCategory = {
    cat_nom: "",
    cat_code: ""
  };

  newPanneCode: CodePanne = {
    code_nom: "",
    cat_id: -1
  };

  public actionsSavList !: Action[];

  
  constructor(private builder: FormBuilder, 
              private service: BreakdownsService, 
              private actionSavService: GestionActionsSavService,
              private dialog: MatDialog, 
              private confirmDialog: DialogConfirmServiceService) { }

  ngOnInit(): void {

    this.buildForm();
    this.loadCategoryList();
    this.loadCodesList();
    this.loadCodesPannesTableList();
  }

  buildForm() {

    this.pannesCategoriesForm = this.builder.group({
      cat_nom: [this.category.cat_nom, Validators.required],
      cat_code: [this.category.cat_code, Validators.required]
    })

    this.codesPannesForm = this.builder.group({
      code_nom: ['', Validators.required],
      cat_id: ['', Validators.required]
    })
  }

  /* User submits the category breakdown form  */
  onSubmitCategoryForm() {
    if (!this.category.cat_id) {
      this.createCategoryPanne();
    }
  }

  /* User submits the code breakdown form  */
  onSubmitCodesPannesForm() {
    this.createPanneCode();
  }

  /* GET the list of breakdowns categories  */
  loadCategoryList() {
    this.service.breakdownsCategoryList().subscribe(list => {
      this.categoryBreakdownList = list;

      this.categoryBreakdownList = this.categoryBreakdownList.filter(function (el) {
        return !el.deleted;
      })

      this.categoryBreakdownList.forEach((element) => {
        this.tCategories.push({ id: element.cat_id, code: element.cat_code });
      })

    })
  }


  /* GET the list of breakdowns codes */
  loadCodesList() {
    this.service.breakdownsCodesList().subscribe(list => {
      list.push({code:"PF0",nom:"PANNEAU CHAMBRE"}) ;
      this.codesBreakdownList = list;
    })
  }


  /**
   * GET the list from codes_pannes table
   */
  loadCodesPannesTableList() {
    this.service.getCodesPannesData().subscribe(list => {
      this.codesPannesList = list;
    })
  }



  /* CREATE a new breakdown category  */
  createCategoryPanne() {

    this.newCategoryBreakdown.cat_nom = this.pannesCategoriesForm.value.cat_nom;
    this.newCategoryBreakdown.cat_code = this.pannesCategoriesForm.value.cat_code;
    this.service.postBreakdownCategory(this.newCategoryBreakdown).subscribe((data) => {
      this.messageDialog = this.newCategoryAddedMsg;
      this.loadCategoryList();
      this.openMessageDialog();
    }, (err) => {
      console.log('ERROR', err);
    })


  }


  /* CREATE a new panne code */
  createPanneCode() {
    this.newPanneCode.code_nom = this.codesPannesForm.value.code_nom;
    this.newPanneCode.cat_id = this.codesPannesForm.value.cat_id;
    this.service.postPanneCode(this.newPanneCode).subscribe((data) => {
      this.messageDialog = this.newCodePanneAddedMsg;
      this.loadCodesList();
      this.openMessageDialog();
    }, (err) => {
      console.log('ERROR', err);
    })
  }

  /* UPDATE category panne */
  editCategory(cat: BreakdownCategory) {

    const dialogRef = this.dialog.open(EditGestionComponent, {
      data: {
        id: cat.cat_id,
        inputs: ['nom de la catégorie', 'code de la catégorie'],
        value: [cat.cat_nom, cat.cat_code],
        form: this.pannesCategoriesForm
      }
    });

    dialogRef.afterClosed().subscribe(
      res => {
        if (res != null) {
          let updateCategory: BreakdownCategory = { cat_nom: "", cat_code: "" };
          updateCategory.cat_nom = res.values[0];
          updateCategory.cat_code = res.values[1];

          this.service.editBreakdownCategory(res.id, updateCategory).subscribe((data) => {
            this.loadCategoryList();
          }, (err) => {
            console.log('ERROR', err);
          })

        } 
      }
    )

  }


  /* UPDATE code breakdown */
  editCodeBreakdown(code: BreakdownCode) {
    let catCode = code.code.slice(0, code.code.search(/\d/));
    let codeId = parseInt(code.code.replace(catCode, ''));
    let catId = -1;

    this.tCategories.forEach((element) => {
      if (element.code == catCode) {
        catId = element.id;
      }
    })

    let form: FormGroup;
    form = this.builder.group({
      code_nom: [code.nom, Validators.required]
    })


    const dialogRef = this.dialog.open(EditGestionComponent, {
      data: {
        id: [catId, codeId],
        inputs: ['nom du code panne'],
        value: [code.nom],
        form: form
      }
    });


    dialogRef.afterClosed().subscribe(
      res => {
        if (res != null) {

          let updateCode: CodePanne = { cat_id: -1, code_id: -1, code_nom: "" };
          updateCode.cat_id = catId;
          updateCode.code_id = codeId;
          updateCode.code_nom = res.values[0];

          this.service.editPanneCode(catId, codeId, updateCode).subscribe((data) => {
            this.loadCodesList();
          }, (err) => {
            console.log('ERROR', err);
          })

        } 
      }
    )
  }



  /* DELETE one category breakdown  */
  onDeleteCategory(id: string, categorie: BreakdownCategory) {

    this.confirmDialog.openConfirmDialog("Voulez-vous supprimer cet élément ?").afterClosed()
      .subscribe(res => {

        if (res) {
          this.service.deleteBreakdownCategory(id, categorie).subscribe((data) => {
            this.messageDialog = this.itemDeletedSuccessMsg;
            this.loadCategoryList();
            this.openMessageDialog();
          }, (err) => {
            console.log('ERROR', err);
            this.messageDialog = this.itemDeletedFailureMsg;
            this.openMessageDialog();
          })

        }

      });


  }

  /* DELETE one code breakdown  */
  onDeleteCode(code: string, body: CodePanne) {
    let catCode = code.slice(0, code.search(/\d/));
    let codeId = parseInt(code.replace(catCode, ''));
    let catId = -1;

    this.tCategories.forEach((element) => {
      if (element.code == catCode) {
        catId = element.id;
      }
    })

    this.confirmDialog.openConfirmDialog("Voulez-vous supprimer cet élément ?").afterClosed()
      .subscribe(res => {

        if (res) {
          this.service.deleteCodePanne(catId, codeId, body).subscribe((data) => {
            this.messageDialog = this.itemDeletedSuccessMsg;
            this.loadCodesList();
            this.openMessageDialog();
          }, (err) => {
            console.log('ERROR', err);
          })
        }


      })

  }

  /* Display the list of all breakdowns categories */
  onClickVoirCategories() {
    this.displayCategoryList = !this.displayCategoryList;
    if (!this.displayCategoryList) {
      this.catMessage = "Afficher la liste";
    } else {
      this.catMessage = "Masquer la liste";
    }

  }


  /* Display the list of all breakdowns codes */
  onClickVoirCodesListe() {

    this.displayCodesList = !this.displayCodesList;
    if (!this.displayCodesList) {
      this.codeMessage = "Afficher la liste";
    } else {
      this.codeMessage = "Masquer la liste";
    }

  }


  /* Alert user when new item is created  */
  public openMessageDialog(): any {
    this.dialog.open(DialogOverViewComponent, {
      width: '20%',
      data: { message: this.messageDialog }
    });
  }



  /* --------------------- LISTES SAV à transmettre dans le component adéquat ------------------------ */



    /* GET the list of types appels sav */
    public loadActionsSavList()   {
        this.actionSavService.getActionsSavList().subscribe(list => {
          this.actionsSavList = list;
          return this.actionsSavList;
        })
      }






}
